// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import Icon_close from '../../img/icons/16/close.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../lib/button';
import styles from './notification_toast.module.less';
import {notification_variant} from './notification_item';

export interface i_notification_toast_props {
    title: string;
    message: string;
    button_text?: string;
    button_link?: string;
    icon_url: string;
    variant?: notification_variant;
    on_delete?: ()=>void;
    open_in_new_tab?: boolean;
    site: string;
    chat_not?: boolean;
}
const variant_icon_map_oculus: Record<notification_variant, string> = {
    bonus: 'https://oculusproxies.com/content/check_toast.svg',
    error: 'https://oculusproxies.com/content/close_toast.svg',
    info: 'https://oculusproxies.com/content/info_toast.svg',
    warning: 'https://oculusproxies.com/content/warning_toast.svg',
};
const variant_icon_map_toolip: Record<notification_variant, string> = {
    bonus: 'https://toolip.io/content/check_toast.svg',
    error: 'https://toolip.io/content/close_toast.svg',
    info: 'https://toolip.io/content/info_toast.svg',
    warning: 'https://toolip.io/content/warning_toast.svg',
};
export const Notification_toast = ({
    title,
    message,
    button_text,
    button_link,
    variant,
    on_delete,
    open_in_new_tab,
    site,
    chat_not
}: i_notification_toast_props)=>{
    const {theme} = useContext(Settings_context);
    const icon_url = site === 'oculus'
      ? variant_icon_map_oculus[variant || 'info']
      : variant_icon_map_toolip[variant || 'info'];
    return <div className={styles.notification_item}>
      <div className={styles.notification}>
        <div className={cn(styles.icon_block,
          styles[variant])}>
            <div
              className={cn(styles.icon_img, styles[variant])}
              style={{
                WebkitMaskImage: `url(${icon_url})`,
                maskImage: `url(${icon_url})`,
              }}/>
          </div>
        <div className={styles.notification_item_content}>
          <div className={styles.notification_title}>
            <p className={cn(styles.notification_title,
              theme.semi, theme.p16)}>
              {title}
            </p>
            <div onClick={on_delete} className={styles.close_icon}>
              <Icon_close/>
            </div>
          </div>
          <p className={cn(theme.p14, styles.notification_message)}>
            {message}
          </p>
          <div className={cn(styles.time, chat_not && styles.chat_not,
            site === 'toolip' && styles.left)}>
            {button_text && <Button
              caption={button_text}
              color="primary"
              round={false}
              fit
              size="s"
              on_click={()=>{
                if (button_link?.startsWith('http'))
                {
                  window.open(button_link, open_in_new_tab ?
                    '_blank' : '_self');
                }
                on_delete();
              }}
              target={open_in_new_tab ? '_blank' : '_self'}
              as_external
              cls={cn(styles.btn)}
              />}
          </div>
        </div>
      </div>
    </div>;
};
